/* Celebra — rotation des vidéos de fond du hero.
 *
 * Conception : UN lecteur par clip, avec sa source fixe. On ne change jamais
 * la source d'un lecteur — c'est ce qui le réinitialise et force le navigateur
 * à retélécharger. Chaque clip est donc chargé une seule fois et conservé en
 * mémoire pour toute la durée de la visite.
 *
 * La rotation se réduit alors à un croisement d'opacités, sans rien d'autre
 * à orchestrer.
 *
 * Chargement progressif : seul le clip 1 est téléchargé à l'ouverture de la
 * page. Le clip 2 ne démarre son chargement qu'une fois le clip 1 lancé, et
 * ainsi de suite. Un visiteur qui reste trois secondes ne paie qu'une vidéo.
 */
(function () {
  function init(conteneur) {
    if (conteneur.__celebraRotate) return;

    var clips = (conteneur.getAttribute('data-hero-rotate') || '').trim().split(/\s+/).filter(Boolean);
    if (clips.length < 2) return;

    var posters = (conteneur.getAttribute('data-hero-posters') || '').trim().split(/\s+/).filter(Boolean);
    var premier = conteneur.querySelector('video');
    if (!premier) return;

    conteneur.__celebraRotate = true;
    var fondu = parseInt(conteneur.getAttribute('data-hero-fade'), 10) || 1000;

    // les z-index restent confinés au conteneur : les vidéos ne passeront
    // jamais devant le titre
    conteneur.style.isolation = 'isolate';

    /* Image de fond sous la couche vidéo : c'est la première image du clip
       en cours. Un lecteur qui n'a pas encore peint sa première frame — au
       chargement, ou juste après un retour à zéro — est transparent ; sans
       cette image, c'est le fond de la section qui apparaît. */
    conteneur.style.backgroundSize = 'cover';
    conteneur.style.backgroundPosition = 'center';
    conteneur.style.backgroundRepeat = 'no-repeat';

    function fond(rang) {
      var url = posters[rang % (posters.length || 1)];
      if (url) conteneur.style.backgroundImage = 'url("' + url + '")';
    }

    /* Un lecteur par clip. Le premier existe déjà (rendu par le thème),
       les suivants sont créés à son image. */
    var lecteurs = [premier];
    for (var i = 1; i < clips.length; i++) {
      var v = premier.cloneNode(false);
      v.removeAttribute('data-testid');
      v.className = premier.className;
      if (posters[i]) v.setAttribute('poster', posters[i]);
      v.setAttribute('src', clips[i]);
      v.preload = 'none'; // il ne se chargera qu'à son tour

      /* Les lecteurs supplémentaires sont SUPERPOSÉS au premier. Sans ça ils
         se placent dans le flux, les uns sous les autres, et se retrouvent
         hors du cadre : on ne voit alors que le conteneur vide au moment de
         la bascule. Le premier lecteur reste dans le flux et continue de
         donner sa taille au bloc. */
      v.style.position = 'absolute';
      v.style.top = '0';
      v.style.left = '0';
      v.style.width = '100%';
      v.style.height = '100%';
      v.style.objectFit = 'cover';

      premier.parentNode.appendChild(v);
      lecteurs.push(v);
    }

    lecteurs.forEach(function (v, rang) {
      v.muted = true;
      v.playsInline = true;
      v.loop = false;
      v.removeAttribute('autoplay'); // c'est le script qui décide
      v.autoplay = false;
      v.style.transition = 'opacity ' + fondu + 'ms ease-in-out';
      v.style.opacity = rang === 0 ? '1' : '0';
      v.style.zIndex = rang === 0 ? '2' : '1';
    });

    var actif = 0;

    function jouer(v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    /* Prépare le clip suivant : on lui demande simplement de se charger.
       Une seule fois — ensuite il garde ses données jusqu'à la fin de la visite. */
    function preparer(rang) {
      var v = lecteurs[rang % lecteurs.length];
      if (v.__prepare) return;
      v.__prepare = true;
      v.preload = 'auto';
      v.load();
    }

    function basculer() {
      var suivant = (actif + 1) % lecteurs.length;
      var sortant = lecteurs[actif];
      var entrant = lecteurs[suivant];

      // il n'a jamais été joué ou vient de finir : on le reprend à son début.
      // Remettre la position à zéro ne retélécharge rien, les données restent.
      try { entrant.currentTime = 0; } catch (e) {}
      fond(suivant); // l'image du clip qui arrive est déjà en place derrière
      jouer(entrant);

      // l'entrant apparaît PAR-DESSUS le sortant resté pleinement visible :
      // à aucun moment le fond de la section ne peut transparaître
      entrant.style.zIndex = '2';
      sortant.style.zIndex = '1';
      entrant.style.opacity = '1';

      actif = suivant;
      preparer(actif + 1);

      setTimeout(function () {
        sortant.style.transition = 'none';
        sortant.style.opacity = '0';
        sortant.pause();
        try { sortant.currentTime = 0; } catch (e) {}
        setTimeout(function () {
          sortant.style.transition = 'opacity ' + fondu + 'ms ease-in-out';
        }, 50);
      }, fondu + 100);
    }

    /* Fin d'un clip : on ne bascule que si le suivant a de quoi jouer.
       Sinon on relance le clip courant — le visiteur voit une boucle,
       jamais un fond figé. */
    lecteurs.forEach(function (v) {
      v.addEventListener('ended', function () {
        if (lecteurs[actif] !== v) return;
        var entrant = lecteurs[(actif + 1) % lecteurs.length];

        if (entrant.readyState >= 3) {
          basculer();
          return;
        }

        /* Le clip suivant n'est pas prêt. On reste sur la DERNIÈRE image du
           clip courant — le relancer depuis son début produirait un retour en
           arrière visible. Une image figée une fraction de seconde passe
           inaperçue ; un redémarrage, non. */
        var bascule = false;
        function partir() {
          if (bascule) return;
          bascule = true;
          if (lecteurs[actif] === v) basculer();
        }
        entrant.addEventListener('canplaythrough', partir, { once: true });
        // au cas où le chargement traînerait vraiment : on bascule quand même,
        // l'image d'attente du clip suivant prend alors le relais
        setTimeout(partir, 3000);
      });
    });

    fond(0);
    jouer(premier);
    if (premier.readyState >= 2) preparer(1);
    else premier.addEventListener('loadeddata', function () { preparer(1); }, { once: true });
  }

  /* Le theme rend DEUX conteneurs quand un media mobile distinct est defini :
     celui de l'ordinateur et celui du telephone. Un seul est affiche a la fois
     (media query a 750px), mais les deux existent dans la page. On ne fait
     tourner que celui qui est visible, et on vide l'autre : sans cela un
     visiteur sur telephone telechargerait aussi les clips 16/9. */

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function neutraliser(conteneur) {
    if (conteneur.__celebraVide) return;
    conteneur.__celebraVide = true;

    var lecteurs = conteneur.querySelectorAll('video');
    for (var i = 0; i < lecteurs.length; i++) {
      var v = lecteurs[i];
      try { v.pause(); } catch (e) {}
      v.removeAttribute('autoplay');
      v.removeAttribute('src');
      v.innerHTML = ''; // retire les <source>
      try { v.load(); } catch (e) {} // interrompt un telechargement en cours
    }

    conteneur.innerHTML = '';
    conteneur.style.backgroundImage = '';
    conteneur.__celebraRotate = false;
  }

  function restaurer(conteneur) {
    if (!conteneur.__celebraVide) return;
    conteneur.__celebraVide = false;
    conteneur.innerHTML = conteneur.__celebraHtml;
  }

  function chercher() {
    var zones = document.querySelectorAll('[data-hero-rotate]');
    for (var i = 0; i < zones.length; i++) {
      var zone = zones[i];
      // etat d'origine, capture avant toute modification
      if (zone.__celebraHtml == null) zone.__celebraHtml = zone.innerHTML;

      if (visible(zone)) {
        restaurer(zone);
        init(zone);
      } else {
        neutraliser(zone);
      }
    }
  }

  /* Rotation de l'ecran ou fenetre redimensionnee : on peut passer d'un
     conteneur a l'autre. */
  var minuteur;
  window.addEventListener('resize', function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(chercher, 200);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chercher);
  else chercher();
})();
